<template>
  <div>
    <a-form class="iotplt-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="EID">
            <a-input
              v-decorator="['eid', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="订单编号">
            <a-input
              v-decorator="['order_no', { normalize: this.$lodash.trim }]"
              allow-clear
              placeholder="支持模糊搜索"
            />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="卡片材质">
            <a-select
              v-decorator="['card_type_id']"
              allow-clear
              placeholder="请选择"
              :loading="loadingCardTypeOptions"
              @change="handleCardTypeChange"
            >
              <a-select-option
                v-for="opt in cardTypeOptions"
                :key="opt.id"
                :value="opt.id"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="卡片尺寸">
            <a-select
              v-decorator="['card_shape_name']"
              allow-clear
              placeholder="请先选择材质"
              :loading="loadingCardShapeOptions"
            >
              <a-select-option
                v-for="opt in cardShapeOptions"
                :key="opt.name"
                :value="opt.name"
              >
                {{ opt.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">搜索</a-button>
              <a-button @click="handleReset">刷新</a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import { findCardTypeOptions, findCardShapeOptions } from '@/api/common_options'

export default {
  name: 'SearchEsim',
  data() {
    return {
      form: this.$form.createForm(this, { name: 'esim_search' }),
      cardTypeOptions: [],
      cardShapeOptions: [],
      loadingCardTypeOptions: false,
      loadingCardShapeOptions: false
    }
  },
  created() {
    this.fetchCardTypeOptions()
  },
  methods: {
    fetchCardTypeOptions() {
      this.loadingCardTypeOptions = true
      findCardTypeOptions().then((res) => {
        if (res.code === 0) {
          this.cardTypeOptions = res.data
        }
        this.loadingCardTypeOptions = false
      }).catch(() => {
        this.loadingCardTypeOptions = false
      })
    },

    handleCardTypeChange(cardTypeId) {
      this.form.setFieldsValue({ card_shape_name: undefined })
      this.cardShapeOptions = []
      if (!cardTypeId) {
        return
      }
      this.loadingCardShapeOptions = true
      findCardShapeOptions(cardTypeId).then((res) => {
        if (res.code === 0) {
          this.cardShapeOptions = res.data
        }
        this.loadingCardShapeOptions = false
      }).catch(() => {
        this.loadingCardShapeOptions = false
      })
    },

    buildSearchParams(values) {
      const search = {}
      Object.keys(values || {}).forEach((key) => {
        const value = values[key]
        if (value === undefined || value === null || value === '') {
          return
        }
        search[key] = value
      })
      return search
    },

    handleSearch(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$emit('submit', this.buildSearchParams(values))
        }
      })
    },

    handleReset() {
      this.form.resetFields()
      this.cardShapeOptions = []
      this.$emit('submit', {})
    }
  }
}
</script>
